import { render, staticRenderFns } from "./home-videos.vue?vue&type=template&id=638cf060&scoped=true&"
import script from "./home-videos.vue?vue&type=script&lang=js&"
export * from "./home-videos.vue?vue&type=script&lang=js&"
import style0 from "./home-videos.vue?vue&type=style&index=0&id=638cf060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638cf060",
  null
  
)

export default component.exports